import React from 'react';
import { Box, Text } from '@chakra-ui/react';
const CanvasElementPlaceholder = ({ clientY, clientX, clientHeight = 0, clientWidth = '0%' }) => {
	const placeholderProps = {
		bg: 'white',
		position: 'absolute',
		top: clientY,
		left: clientX,
		height: clientHeight,
		width: clientWidth,
		backgroundColor: '#fffee6',
		padding: '0px',
		d: 'flex',
	};

	const placeholderDotted = {
		border: 'dashed 2px #ecc94b',
		borderRadius: '3px',
		margin: '8px 8px 5px 8px',
		w: '100%',
		verticalAlign: 'middle',
		d: 'flex',
	};

	const textStyle = {
		color: '#ecc94b',
		fontWeight: 700,
		fontSize: '18px',
		alignSelf: 'center',
		margin: '0 auto',
	};

	if (!clientHeight) return null;

	return (
		<Box {...placeholderProps}>
			<Box {...placeholderDotted}>
				<Text {...textStyle}>Solte para posicionar</Text>
			</Box>
		</Box>
	);
};

export default CanvasElementPlaceholder;
